export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7927.e7ad1566.jpg";